// extracted by mini-css-extract-plugin
export var deleteModal = "_qa-0";